import React from 'react';
import propTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

export default function CustomHeader({ title, subtitle, description, to }) {
  const history = useHistory();
  return (
    <div className="d-flex mt-2 p-2 flex-column">
      <div className="d-flex">
        {to && <FaArrowLeft onClick={() => history.push(to)} className="back-icon" />}
        <h4 className="d-flex w-100 justify-content-center">{title}</h4>
      </div>
      {subtitle && (
        <>
          <span>{subtitle}</span>
          {description && <h5>{description}</h5>}
        </>
      )}
    </div>
  );
}

CustomHeader.propTypes = {
  title: propTypes.string.isRequired,
  subtitle: propTypes.string,
  description: propTypes.string,
  to: propTypes.string,
};

CustomHeader.defaultProps = {
  to: null,
  subtitle: null,
  description: null,
};
